import { NavDrawer, NavDrawerProps } from "@fluentui/react-nav-preview";
import { FluentProvider, PartialTheme, webDarkTheme, webLightTheme } from "@fluentui/react-components";
import { ETheme } from "@/DependenciesV9";

export interface NavDrawerCustomProps {
  rcName?: string;
  theme?: ETheme;
}

const NavDrawerCustom = (props: NavDrawerCustomProps & NavDrawerProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return props.theme ?
    <FluentProvider theme={
      props.theme === "dark"
        ? {
          ...webDarkTheme, colorNeutralBackground1: "#292929",
          colorNeutralBackground4: "#292929",
          colorNeutralBackground4Hover: "#0a0a0a",
        }
        : {
          ...renderTheme,
          colorNeutralBackground1: "#F8F8F8",
          colorNeutralBackground4: "#F8F8F8",
          colorNeutralBackground4Hover: "rgb(255, 255, 255)",
        }
    }>
      <NavDrawer {...props}/>
    </FluentProvider> : <NavDrawer {...props}/>
};

export default NavDrawerCustom;